import React from "react";
import { Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { PAGE_TITLES } from "../Common/constants";
import { ToastContainer, toast } from "react-toastify";

function EVBusinessPerformanceReportBreadCrumbs() {
  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <BreadCrumb
            title={PAGE_TITLES.BUSINESS_PERFORMANCE_REPORT}
            pageTitle={PAGE_TITLES.BUSINESS_PERFORMANCE_REPORT}
            showBreadcrumb={false}
          />
          <ToastContainer position="top-center" />
        </Container>
      </div>
    </React.Fragment>
  );
}

export default EVBusinessPerformanceReportBreadCrumbs;
